<template>
  <v-app>
    <template v-if="isLog">
      <app-drawer @logout="logout" />
      <app-navbar />
    </template>
    <v-main id="mainContent">
      <router-view v-if="!needAuth || (needAuth && isLog && isSuperAdmin)" />
      <div
        v-else-if="isLog && !isSuperAdmin"
        class="not-allowed">
        Ce compte n'a pas le profil superadmin sur l'environnement {{ $env.label }}.
      </div>
    </v-main>
    <confirm-dialog />
    <back-to-top v-if="isLog" />
  </v-app>
</template>

<script>
  import './styles/app.scss'
  import { mapGetters, mapState } from 'vuex'
  import AppNavbar from './components/AppNavbar'
  import AppDrawer from './components/AppDrawer'
  import ConfirmDialog from './components/ConfirmDialog'
  import BackToTop from './components/BackToTop'
  import { tokenKey } from './environments'

  export default {
    name: 'App',
    components: { AppDrawer, AppNavbar, ConfirmDialog, BackToTop },
    computed: {
      ...mapState(['currentUser', 'token']),
      ...mapGetters(['isLog', 'isSuperAdmin']),
      needAuth () {
        return 'authRequired' in this.$route.meta && this.$route.meta.authRequired
      },
      storageKey () {
        return tokenKey(this.$env)
      }
    },
    watch: {
      token (val) {
        if (val) {
          this.login(val)
        }
      }
    },
    created () {
      // reprise de l'ancienne session (clé unique, avant le sélecteur d'environnement)
      const legacyToken = localStorage.getItem('vadimm-admin-token')
      if (legacyToken) {
        if (!localStorage.getItem(this.storageKey)) localStorage.setItem(this.storageKey, legacyToken)
        localStorage.removeItem('vadimm-admin-token')
      }
      const token = localStorage.getItem(this.storageKey)
      if (token) {
        this.$store.commit('setToken', token)
      } else if (this.$route.name !== 'login') {
        this.$router.replace({ name: 'login' })
      }
    },
    methods: {
      async login (token) {
        localStorage.setItem(this.storageKey, token)
        this.$api.setToken(token)
        try {
          const userRequest = await this.$api.getCurrentUser()
          this.$store.commit('setCurrentUser', userRequest.data)
        } catch (e) {
          // session expirée ou invalide sur cet environnement
          await this.logout()
          return
        }
        if (this.$route.name === 'login') {
          const redirect = this.$route.query.redirect
          await this.$router.replace(redirect || { name: 'dashboard' })
        }
      },
      async logout () {
        localStorage.removeItem(this.storageKey)
        this.$api.setToken(null)
        this.$store.commit('logout')
        if (this.$route.name !== 'login') {
          await this.$router.replace({ name: 'login' })
        }
      }
    }
  }
</script>

<style>
  .not-allowed {
    padding: 48px;
    color: #71717a;
  }
</style>
